import React from "react";
import "./SkillsetVisual.css";

/* Coding terminal */
export const TerminalVisual = () => (
  <div className="sv-terminal" aria-hidden="true">
    <div className="sv-terminal-bar">
      <span /><span /><span />
      <em>~/nexite/app — zsh</em>
    </div>
    <pre className="sv-terminal-body">
      <code>
        <span className="sv-line">
          <span className="sv-ln">1</span>
          <span className="sv-tok-key">import</span> {"{ build }"}{" "}
          <span className="sv-tok-key">from</span>{" "}
          <span className="sv-tok-str">"nexite"</span>;
        </span>
        <span className="sv-line">
          <span className="sv-ln">2</span>
          <span className="sv-tok-key">const</span> app ={" "}
          <span className="sv-tok-fn">create</span>(
          <span className="sv-tok-num">2026</span>);
        </span>
        <span className="sv-line">
          <span className="sv-ln">3</span>
          <span className="sv-tok-key">await</span> app.
          <span className="sv-tok-fn">build</span>();
        </span>
        <span className="sv-line sv-muted">
          <span className="sv-ln"> </span>✓ compiled in 1.2s
        </span>
        <span className="sv-line">
          <span className="sv-ln">$</span>
          <span className="sv-typed">npm run deploy</span>
          <span className="sv-caret">▍</span>
        </span>
      </code>
    </pre>
    <div className="sv-terminal-status">
      <span className="sv-status-dot" /> build: passing
      <span className="sv-progress"><span /></span>
    </div>
  </div>
);

/* Analytics dashboard */
export const DashboardVisual = () => (
  <div className="sv-card sv-dashboard" aria-hidden="true">
    <div className="sv-dash-head">
      <div>
        <span className="sv-dash-title" />
        <span className="sv-dash-sub" />
      </div>
      <span className="sv-dash-pill">+24%</span>
    </div>
    <div className="sv-dash-stat">8.4k</div>
    <svg className="sv-spark" viewBox="0 0 120 40" preserveAspectRatio="none">
      <polyline
        className="sv-spark-line"
        points="0,32 20,24 40,28 60,14 80,18 100,6 120,10"
      />
    </svg>
    <div className="sv-bars">
      {[45, 70, 55, 90, 65, 80].map((h, i) => (
        <span key={i} style={{ "--h": `${h}%` }} />
      ))}
    </div>
    <div className="sv-legend">
      <span><i className="sv-dot-a" />Sales</span>
      <span><i className="sv-dot-b" />Leads</span>
    </div>
  </div>
);

/* Mobile app frame */
export const MobileVisual = () => (
  <div className="sv-phone" aria-hidden="true">
    <span className="sv-phone-notch" />
    <div className="sv-phone-status">
      <span>9:41</span>
      <span className="sv-phone-icons"><i /><i /><i /></span>
    </div>
    <div className="sv-phone-screen">
      <div className="sv-phone-topbar">
        <span className="sv-phone-avatar" />
        <div className="sv-phone-titles">
          <span className="sv-phone-line" style={{ width: "62px" }} />
          <span className="sv-phone-line sv-sm" style={{ width: "42px" }} />
        </div>
        <span className="sv-phone-bell" />
      </div>
      <div className="sv-phone-card">
        <div className="sv-phone-minibars"><span /><span /><span /><span /></div>
      </div>
      <div className="sv-phone-row">
        <span>Push aktiv</span>
        <span className="sv-toggle"><i /></span>
      </div>
      <span className="sv-phone-btn">Weiter</span>
      <div className="sv-phone-nav"><i /><i /><i /><i /></div>
    </div>
  </div>
);

/* Browser / web layout */
export const BrowserVisual = () => (
  <div className="sv-browser" aria-hidden="true">
    <div className="sv-browser-bar">
      <span /><span /><span />
      <em className="sv-url">https://nexite-it.de</em>
    </div>
    <div className="sv-browser-load" />
    <div className="sv-browser-body">
      <span className="sv-block sv-block-hero" />
      <div className="sv-block-row">
        <span className="sv-block" />
        <span className="sv-block" />
        <span className="sv-block" />
      </div>
      <div className="sv-block-row">
        <span className="sv-block sv-wide" />
        <span className="sv-block sv-narrow" />
      </div>
      <span className="sv-cursor" />
    </div>
  </div>
);

/* Automation / RPA flow */
export const AutomationVisual = () => (
  <div className="sv-card sv-flow" aria-hidden="true">
    <div className="sv-flow-track">
      <span className="sv-node"><span className="sv-node-ico" /></span>
      <span className="sv-arrow" />
      <span className="sv-node sv-node-accent"><span className="sv-gear" /></span>
      <span className="sv-arrow" />
      <span className="sv-node"><span className="sv-node-ico" /></span>
      <span className="sv-flow-dot" />
    </div>
    <div className="sv-flow-labels"><span /><span /><span /></div>
  </div>
);

/* Registry: map a string key -> component */
const VISUALS = {
  terminal: TerminalVisual,
  dashboard: DashboardVisual,
  mobile: MobileVisual,
  browser: BrowserVisual,
  automation: AutomationVisual,
};

/* Renderer used by the section */
const SkillsetVisual = ({ visual }) => {
  const Component = VISUALS[visual] || TerminalVisual;
  return <Component />;
};

export default SkillsetVisual;